window.addEventListener('DOMContentLoaded', () => {

    document.addEventListener("click", (event) => {
        const target = event.target;

        const trackIfMatch = (selector, event_name) => {
            if (target.closest(selector)) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: event_name
                });
            }
        };

        // Variant B
        trackIfMatch(".test-qty-selector-VB .quantity__button-plus", "plus_btn_qty_selector");
        trackIfMatch(".test-qty-selector-VB .quantity__button-minus", "minus_btn_qty_selector");

        // control group (Variant A)
        trackIfMatch(".test-qty-selector-VA .quantity__button-plus", "original_plus_btn_qty_selector");
        trackIfMatch(".test-qty-selector-VA .quantity__button-minus", "original_minus_btn_qty_selector");
    });

});